import { useState } from "react";
import Success from "../../../images/Sucess.svg";
import ParticularTicketDetails from "./common/ParticularTicketDetails";
import { CustomDrawerInMobile } from "../../../styles/CustomDrawerStyles";
import FollowUpStatus from "./FollowUpStatus";
import { TicketStatus } from "../../../utils/constants";
import Close from "../../../images/Close.svg";

interface Props {
  setModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const TicketDetails = ({ setModal }: Props) => {
  const [followUpStatus, setFollowUpStatus] = useState(false);
  const [ticketStatus, setTicketStatus] = useState(TicketStatus.ALL);

  return (
    <>
      <div className="mobile-tkt-details">
        <div className="mobile-followup__title">
          <img
            src={Close}
            alt=""
            onClick={() => {
              setModal(false);
            }}
          />
        </div>
        <div className="mobile-tkt-details--success">
          <img src={Success} alt="" />
          <span>Ticket Raised Successfully</span>
        </div>
        {/* already exists */}
        {/* <div className="mobile-tkt-details--raised-already">
        <img src={Exists} alt="" />
        <span>Ticket Raised Successfully</span>
      </div> */}
        <div className="mobile-tkt-details--block">
          <ParticularTicketDetails setTicketStatus={setTicketStatus} />

          <button onClick={() => setFollowUpStatus(!followUpStatus)}>
            View Details
          </button>
        </div>
      </div>
      {/* <button className="mobile-tkt-details--clear">Clear</button> */}

      <CustomDrawerInMobile
        anchor="bottom"
        open={followUpStatus}
        onClose={() => setFollowUpStatus(!followUpStatus)}
      >
        <FollowUpStatus setModal={setFollowUpStatus} />
      </CustomDrawerInMobile>
    </>
  );
};

export default TicketDetails;
